/**
 * Customer survey URL for ambassador QR codes.
 * Must match packages/staff/src/config/surveyUrl.js so admin "My QR Code"
 * encodes the same link as the ambassador profile page.
 */

function surveyFrontendBase(): string {
  const fromEnv = import.meta.env.VITE_SURVEY_FRONTEND_URL;
  if (typeof fromEnv === 'string' && fromEnv.trim()) {
    return fromEnv.trim().replace(/\/$/, '');
  }

  if (typeof window === 'undefined') {
    return 'http://localhost:5174';
  }

  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Injected at dev-server start by packages/admin/vite.config.ts
    const lanIp = typeof __DEV_LAN_IP__ !== 'undefined' ? __DEV_LAN_IP__ : null;
    if (lanIp) {
      return `http://${lanIp}:5174`;
    }
    return 'http://localhost:5174';
  }

  return `http://${hostname}:5174`;
}

export function buildStaffSurveyQrUrl(staffCode: string | null | undefined): string {
  if (!staffCode?.trim()) return '';
  return `${surveyFrontendBase()}/?ref=${encodeURIComponent(staffCode.trim())}`;
}

export function getSurveyFrontendBase(): string {
  return surveyFrontendBase();
}
